/* eslint-disable react/jsx-key */
import { ErrorMessage, FieldArray, Form, Formik } from "formik";
import React, { useState } from "react";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Form as BForm, Card } from "react-bootstrap";
import DeleteModel from "../deleteModel";
import { getSecurityDataSelector } from "../../../../../store/selector/cmsSelector";
import addSecurityDataAction from "../actions";

const validationSchema = Yup.object({
  faqs: Yup.array()
    .of(
      Yup.object().shape({
        title: Yup.string().required("title can not be empty"),
        paragraph: Yup.string().required("paragraph can not be empty"),
      }),
    )
    .required("FAQ can not be empty")
    .min(1, "please add minimum 1 FAQ"),
});

function Faq() {
  const [faqEdit, setFaqEdit] = useState(false);
  const state = useSelector(getSecurityDataSelector);
  const dispatch = useDispatch();
  const initialState = {
    faqs: state?.faqs
      ? state?.faqs
      : [
          {
            title: "",
            paragraph: "",
          },
        ],
  };

  const handleSubmit = async (values: any) => {
    setFaqEdit(false);
    const formData = new FormData();
    formData.append("faqs", JSON.stringify(values.faqs));
    formData.append("request_type", "faq");
    dispatch(addSecurityDataAction(formData, setFaqEdit));
  };

  return (
    <Formik enableReinitialize initialValues={initialState} validationSchema={validationSchema} onSubmit={handleSubmit}>
      {({ values, errors, setFieldValue }) => {
        return (
          <Form>
            <Card>
              <Card.Header className="d-flex justify-content-between align-items-center">
                <h6 className={`mb-0 ${faqEdit ? "editTitle" : ""}`}>FAQ</h6>
                {faqEdit ? (
                  <button className="btn btn-primary" type="submit">
                    Save <i className="fa-regular fa-floppy-disk ms-1" />
                  </button>
                ) : (
                  <span aria-hidden="true" onClick={() => setFaqEdit(true)} className="btn btn-green">
                    Edit <i className="fa-regular fa-pen-to-square ms-1" />
                  </span>
                )}
              </Card.Header>
              <Card.Body className="position-relative">
                <div
                  className={`position-absolute w-100 h-100 start-0 top-0 zIndex-1 ${faqEdit ? "d-none" : ""}`}
                  style={{ background: "rgba(255,255,255,0.5)", cursor: "not-allowed" }}
                />
                <FieldArray
                  name="faqs"
                  render={(arrayHelpers) => (
                    <>
                      {values?.faqs?.map((_value: any, index: any) => (
                        <div className="faqQuestionsWrap position-relative">
                          <div className="d-flex justify-content-between align-items-center mb-20">
                            <span className="labelCount">0{index + 1}</span>
                            {faqEdit ? (
                              <>
                                {" "}
                                {values?.faqs?.length > 1 && (
                                  <DeleteModel
                                    onClick={() => {
                                      arrayHelpers.remove(index);
                                    }}
                                  />
                                )}
                              </>
                            ) : null}
                          </div>
                          <div>
                            <BForm.Label className="form-label" htmlFor={`faqs${index + 1}`}>
                              Title
                            </BForm.Label>
                            <BForm.Control
                              name={`faqs[${index}].title`}
                              placeholder="question"
                              id={`faqs${index + 1}`}
                              readOnly={!faqEdit}
                              disabled={!faqEdit}
                              value={values?.faqs?.[index]?.title}
                              onChange={(e) => setFieldValue(`faqs[${index}].title`, e.target.value)}
                            />
                            <ErrorMessage name={`faqs[${index}].title`} className="errorMessage" component="div" />
                          </div>
                          <div className="mt-3">
                            <BForm.Label className="form-label" htmlFor="paragraph">
                              Paragraph
                            </BForm.Label>
                            <div className="editField mb-0">
                              {/* <Field name={`faqs[${index}].paragraph`} component="textarea" readOnly={!faqEdit} disabled={!faqEdit} /> */}
                              <CKEditor
                                editor={ClassicEditor}
                                data={values?.faqs?.[index]?.paragraph}
                                name={`faqs[${index}].paragraph`}
                                className="ekEditorWrap"
                                readOnly={!faqEdit}
                                disabled={!faqEdit}
                                onChange={(_event: any, editor: any) => {
                                  const data = editor.getData();
                                  setFieldValue(`faqs[${index}].paragraph`, data);
                                }}
                              />
                              <ErrorMessage name={`faqs[${index}].paragraph`} className="errorMessage" component="div" />
                            </div>
                          </div>
                        </div>
                      ))}
                      {faqEdit ? (
                        <button
                          type="button"
                          className="addNewItem"
                          onClick={() =>
                            arrayHelpers.push({
                              // id:Date.now(),
                              title: "",
                              paragraph: "",
                            })
                          }
                        >
                          Add Item
                        </button>
                      ) : null}
                    </>
                  )}
                />
                {typeof errors.faqs === "string" ? <p className="errorMsg">{errors.faqs}</p> : null}
              </Card.Body>
            </Card>
          </Form>
        );
      }}
    </Formik>
  );
}

export default withRouter(Faq);
